export default "__VITE_ASSET__DZreIZby__"